import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
import { IconBase } from '../Base';
export const IconPhoneLines = (props) => {
    return (React.createElement(IconBase, { viewportSize: 8, ...props },
        React.createElement("g", { style: { stroke: 'var(--icon-color)' }, strokeWidth: "1", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("path", { d: "M2.00001 2.75C2.00001 2.75 3.12677 3.45 4.00001 3.45C4.87325 3.45 6.00001 2.75 6.00001 2.75" }),
            React.createElement("path", { d: "M1.00001 4.25C1.00001 4.25 2.60001 5.25 4.00001 5.25C5.40001 5.25 7.00001 4.25 7.00001 4.25" }))));
};
const Wrapper = styled.div `
  --phone-rotate: 0deg;
  --phone-lines-1: 0;
  --phone-lines-2: 0;
  position: relative;
  display: table;
  svg {
    --icon-color: ${({ theme }) => theme.primary.background};
  }
`;
const Phone = styled.div `
  transform: rotate(var(--phone-rotate)) translateZ(0);
`;
const Left = styled(IconPhoneLines) `
  --icon-size: 8px;
  position: absolute;
  left: -2px;
  bottom: -2px;
  transform: rotate(45deg);
  path {
    opacity: var(--phone-lines-1);
    &:last-child {
      opacity: var(--phone-lines-2);
    }
  }
`;
const Right = styled(IconPhoneLines) `
  --icon-size: 8px;
  position: absolute;
  right: -2px;
  top: -2px;
  transform: rotate(225deg);
  path {
    opacity: var(--phone-lines-1);
    &:last-child {
      opacity: var(--phone-lines-2);
    }
  }
`;
export const IconPhone = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            gsap.to(wrapperRef.current, {
                '--phone-rotate': '-20deg',
                duration: 0.1,
                onComplete: (target) => {
                    gsap.to(target, {
                        repeat: 1,
                        keyframes: [
                            {
                                '--phone-lines-1': 1,
                                duration: 0.1,
                            },
                            {
                                '--phone-lines-2': 1,
                                duration: 0.1,
                            },
                            {
                                '--phone-lines-1': 0,
                                duration: 0.1,
                            },
                            {
                                '--phone-lines-2': 0,
                                duration: 0.1,
                            },
                        ],
                    });
                    gsap.to(target, {
                        onComplete: () => {
                            gsap.to(target, {
                                '--phone-rotate': '0deg',
                                duration: 0.15,
                                onComplete: () => {
                                    triggerDone();
                                },
                            });
                        },
                        keyframes: new Array(3)
                            .fill([
                            {
                                '--phone-rotate': '-23deg',
                                duration: 0.1,
                            },
                            {
                                '--phone-rotate': '-17deg',
                                duration: 0.1,
                            },
                        ])
                            .flat(),
                    });
                },
                onCompleteParams: [wrapperRef.current],
            });
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Left, null),
        React.createElement(Right, null),
        React.createElement(Phone, null,
            React.createElement(Icon.Phone, null))));
};
//# sourceMappingURL=Phone.js.map